import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import calendarpng from "./../../Asset/New_Assert/ESO_Icon/Filter.svg";
import pdficon from "./../../Asset/PDF.png";
import csvicon from "./../../Asset/CSV.png";
import { interpolateRgb } from "d3-interpolate";
import { color } from "d3-color";
import LiquidFillGauge from "react-liquid-gauge";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import { styled, useTheme } from "@mui/material/styles";
import Pagination from '@mui/material/Pagination';
import MSelect from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useSelector } from "react-redux";
import Loader from "../../CommonLoader";
import { Tooltip, Typography } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CommonAlert, { GetuserDatavalue } from "../../../../Commonalert/commonalert";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import DatagridComp from "../../DatagridComp";
import { CommonErrorAlert } from "../../../../Commonalert/commonErrorAlert";
import { Container, Grid } from '@mui/material';
import UserActivityTracker from "../../../../hooks/userActivityTracker";
import Chart from "react-apexcharts";
import Commoncard from "../../Commoncard";
import WarningCount from "../../Asset/esocardicon/SchemaDetail/WarningCount.svg";
import ErrorCount from "../../Asset/esocardicon/SchemaDetail/ErrorCount.svg";
import Select from "react-select";
import { customDropdownStyles } from "../../../../Commonalert/commonDropdown";
import { removeDuplicateDate } from "../../Commonfun";


export default function NewLinks(props) {

  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tablecardData, setTableCardData] = useState([]);
  const [LinkUrl, SetLinkUrl] = useState('')
  const esodata = useSelector((state) => state);
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [summaryData, setSummaryData] = useState({
    "historical_trend": [],
    "top_5_authority_impact": [],
    "follow_vs_nofollow": {
      "follow": 0,
      "nofollow": 0
    },
    "summary": {
      "total_count": 0,
      "link_type_displayed": ""
    }
  })
  const navigate = useNavigate();
  const ApiToken = esodata.apiauthkey.value;
  const [OpenModalJob, SetOpenModalJob] = useState(false);
  const [completedate, Setcompletedate] = useState([]);
  const [Selectval, setSelectval] = useState("");

  const [dEngineoption, SetdEngineoption] = useState({
    completed_at: "Select Date",
    id: "Select Date",
  });

  const [validationFiter, SetvalidationFiter] = useState("");

  const [jobvalsel, SetJobvalsel] = useState("");

  const [FollowType, SetFollowType] = useState({
    value: "all",
    label: "All",
  });

  const [followTypeErr, SetFollowTypeErr] = useState("");
  const CloseModalJobTrigger = () => {
    SetOpenModalJob(false);
    SetFollowTypeErr("");
  };

  const OpenModalJobTrigger = () => {
    SetOpenModalJob(true);
  };

  useEffect(() => {
    GetuserDatavalue(setOpenCommonAlerts, ApiToken, navigate);
    callUserdataApi();
    GetReportJobDates();
  }, []);

  const apihandleClose = () => {
    setapiOpen(false);
  };
  const GetReportJobDates = async () => {
    setLoading(true);

    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=backlinks`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (
          error?.response?.status == 599 ||
          error?.response?.status == 400 ||
          error?.response?.status == 500
        ) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error);
        } else if (
          error?.code == "ERR_NETWORK" ||
          error?.response?.status == 404
        ) {
          navigate("/errorpages");
        }
      });

      setLoading(false);

      if (datavalue?.data?.jobs?.length > 0) {
        const uniqueByCompletedAt = removeDuplicateDate(datavalue.data.jobs);

        Setcompletedate(uniqueByCompletedAt);
        SetdEngineoption(uniqueByCompletedAt[0]);
        setSelectval(uniqueByCompletedAt[0]);
      }
    } catch (err) {
      setLoading(false);
    }
  };
  const TriggerFilter = () => {
    let hasError = 1;

    if (Selectval === "" || !Selectval?.value) {
      SetvalidationFiter("Please select the completed date");
      hasError = 2;
    } else {
      SetvalidationFiter("");
    }

    if (FollowType === "" || !FollowType?.value) {
      SetFollowTypeErr("Please select the follow type");
      hasError = 2;
    } else {
      SetFollowTypeErr("");
    }

    if (hasError === 2) {
      return false;
    }

    const JobId = Selectval.value;
    const FollowTypeValue = FollowType.value;

    SetJobvalsel(JobId);

    callUserdataApi(JobId, FollowTypeValue);
    SetOpenModalJob(false);
  };
  const handleFilterReset = () => {
    SetFollowType({
      value: "all",
      label: "All",
    });

    setSelectval("");

    SetdEngineoption({
      completed_at: "Select Date",
      id: "Select Date",
    });

    SetvalidationFiter("");
    SetFollowTypeErr("");
    SetJobvalsel("");

    callUserdataApi("", "all");
    SetOpenModalJob(false);
  };
  const callUserdataApi = async (jobid = "", selectedFollowType = "") => {
    setLoading(true);
    setTableLoading(true);
    var JobId = "";

    if (jobid) {
      JobId = jobid;
    } else if (Selectval && Selectval.value) {
      JobId = Selectval.value;
    } else if (props.RankJob) {
      if (props.RankJob.value) {
        JobId = props.RankJob.value;
      }
    }
    const FollowTypeValue = selectedFollowType
      ? selectedFollowType
      : FollowType?.value || "all";
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_new_lost/?link_type=new&user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${JobId}&follow_type=${FollowTypeValue}`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setCardData("");
          SetAutoheightval(true)
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data) {
        if (datavalue?.data?.job_date) {
          setCardData("");
          SetAutoheightval(true)
          props.setjobDate(moment(datavalue.data.job_date).format("MMMM DD,YYYY HH:mm"));
        }
        setSummaryData({
          "historical_trend": datavalue?.data?.new_links_table?.charts?.historical_trend || [],
          "top_5_authority_impact": datavalue?.data?.new_links_table?.charts?.top_5_authority_impact || [],
          "follow_vs_nofollow": {
            "follow": datavalue?.data?.new_links_table?.charts?.follow_vs_nofollow?.follow || 0,
            "nofollow": datavalue?.data?.new_links_table?.charts?.follow_vs_nofollow?.nofollow || 0
          },
          "summary": {
            "total_count": datavalue?.data?.new_links_table?.charts?.summary?.total_count || 0,
            "link_type_displayed": datavalue?.data?.new_links_table?.charts?.summary?.link_type_displayed || ""
          }
        })
      }
      SetLinkUrl(datavalue?.data?.link_url)
      const dataval = datavalue?.data?.new_links_table?.new_links;
      if (dataval && dataval.length > 0) {
        const newData = dataval.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        setCardData(newData);
        SetAutoheightval(false)
      }
      else {
        setCardData("");
        SetAutoheightval(true)
      }
    } catch (err) {
      console.log('err', err)
      setCardData("");
      SetAutoheightval(true)
    }
    setTableLoading(false);
    setLoading(false);
  };
  const columns = [

    {
      field: "date_found",
      headerName: "Date Found",
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: "Recent referring domains date.",
    },
    {
      field: "title",
      headerName: "Title/Referring page",
      minWidth: 400,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      description: "Referring page's title/Referring page's URL.",
      renderCell: (cardData) => {

        let firstEightLetters = cardData?.row?.referring_page;
        let whoedata = firstEightLetters;

        let baseUrl = cardData?.row?.referring_page.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData?.row?.referring_page.split("/").slice(3).join("/");
        return (
          <div classname="link-dt-left"><span style={{ color: "hsl(38.3deg 100% 56.08%)" }}>{cardData.row.title}</span>
            <br />

            <Tooltip title={cardData?.row?.referring_page}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.referring_page} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    // {
    //   field: "da",
    //   headerName: "DA",
    //   minWidth: 100,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: true,
    //   description: "Domain InLink Rank of the target's root domain.",
    // },
    {
      field: "da",
      headerName: "DA",
      minWidth: 100,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Domain InLink Rank of the target's root domain.",
      renderCell: (cardData) => {
        var sr = cardData.row.da;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: '#0b2033',
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
          />
        );
      },
    },
    // {
    //   field: "pa",
    //   headerName: "PA",
    //   minWidth: 100,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: true,
    //   description: "InLink rank of the target URL.",
    // },
    {
      field: "pa",
      headerName: "PA",
      minWidth: 120,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "InLink rank of the target URL.",
      renderCell: (cardData) => {
        var sr = cardData.row.pa;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: "#0b2033",
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
            }}
          />
        );
      },
    },
    {
      field: "anchor",
      headerName: "Anchor/Target Page",
      minWidth: 400,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      description: "Link anchor text for text links/Destination page's URL.",
      renderCell: (cardData) => {
        let baseUrl = cardData?.row?.target_page?.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData?.row?.target_page?.split("/").slice(3).join("/");
        let baseUrl1 = cardData?.row?.anchor?.split("/").slice(0, 3).join("/") || '' + "/";
        let remaining1 = cardData?.row?.anchor?.split("/").slice(3).join("/") || '';
        return (
          <div classname="link-dt-left"><span style={{ color: "hsl(38.3deg 100% 56.08%)" }}>
            {baseUrl1}<br />
            {remaining1}
          </span>
            <br />
            <Tooltip title={cardData.row.target_page}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.target_page} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "link_type",
      headerName: "Link Type",
      minWidth: 130,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: "Type of backlink.",
    },
    {
      field: "nofollow",
      headerName: "Follow/No Follow",
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: "Number of backlinks marked as nofollow and number of backlinks NOT marked as nofollow.",
    },
    {
      field: "first_seen",
      headerName: "First Seen",
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: "The date when the backlink was discovered and added to the index.",

    },
  ];

  const rows = cardData ?? [];
  // useEffect(() => {
  //   if (props.FilterButtonTriggered === true) {
  //     callUserdataApi()
  //     props.SetFilterButtonTriggered(false)
  //     props.closeModal()
  //   }

  // }, [props])

  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = "rgb(255,174,31)";
  const textfillColor = "rgb(255,255,255)";
  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];

  const handleModelPopUp = () => {
    OpenModalJobTrigger();
  };

  const handleDownlodingCSV = () => {
    props.csvdown();
  }

  const handleDownlodingPDF = () => {
    props.pdfdown();
  }

  const cardDatas = [
    {
      value: summaryData.follow_vs_nofollow.follow || 0,
      title: "Follow",
      // badge: "SEO",
      iconSrc: ErrorCount,
      iconColor: 1,
      bgColor: 1,
    },
    {
      value: summaryData.follow_vs_nofollow.nofollow || 0,
      title: "No Follow",
      // badge: "TRAFFIC",
      iconSrc: WarningCount,
      iconColor: 2,
      bgColor: 2,
    },
    // {
    //   value: summaryData.summary.link_type_displayed || 0,
    //   title: "Link Type Displayed",
    //   // badge: "SEO",
    //   iconSrc: ErrorCount,
    //   iconColor: 3,
    //   bgColor: 3,
    // },
    {
      value: summaryData.summary.total_count || 0,
      title: "Total Count",
      // badge: "TRAFFIC",
      iconSrc: WarningCount,
      iconColor: 4,
      bgColor: 4,
    },
  ];

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false }
    },
    colors: ["#0e2f9a", "#b81414"],
    plotOptions: {
      bar: {
        horizontal: true, // better for long URLs
        barHeight: "60%"
      }
    },
    xaxis: {
      categories: summaryData.historical_trend?.map(item => item.date) || [],
      labels: {
        show: false   // 👈 hides numbers/text on x-axis
      },
      axisBorder: {
        show: false   // optional: remove axis line
      },
      axisTicks: {
        show: false   // optional: remove ticks
      }
    },
    yaxis: {
      labels: {
        maxWidth: 150
      }
    },
    grid: {
      padding: {
        left: 20,
        right: 20
      }
    },
    tooltip: {
      x: {
        formatter: (val, opts) => summaryData.historical_trend[opts.dataPointIndex]?.date
      },
      y: {
        formatter: (val) => val
      }
    }
  };

  const chartSeries = [
    {
      name: "New Count",
      data: summaryData.historical_trend?.map(item => item.new_count) || []
    },
    {
      name: "Lost Count",
      data: summaryData.historical_trend?.map(item => item.lost_count) || []
    }
  ];


  return (
    <div >
      {loading === true ? <Loader /> : null}

      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>

          <Grid container spacing={3} xs={12} sm={12} md={12} justifyContent="center">
            {cardDatas.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                <Commoncard
                  item={item}
                  nonclikable={true}
                />
              </Grid>
            ))}
          </Grid>

          <Grid item xs={12} md={6}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '400px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Historical Trend</Typography>
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="bar"
                height={350}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '400px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Top 5 Authority Impact</Typography>
              <Chart
                type="bar"
                height={350}
                series={[{ name: "DA", data: summaryData?.top_5_authority_impact.map(i => i.da) }]}
                options={{
                  chart: { toolbar: { show: false } },
                  plotOptions: { bar: { horizontal: true, barHeight: '30%', borderRadius: 4 } },
                  colors: ["#2e7d32"],
                  xaxis: { categories: summaryData?.top_5_authority_impact.map(i => i.domain), labels: { show: false } },
                  dataLabels: { enabled: true, formatter: (val) => `${val}`, position: 'right' },
                  tooltip: {
                    custom: ({ dataPointIndex }) => {
                      const item = summaryData?.top_5_authority_impact[dataPointIndex];
                      return `
                    <div style="padding:8px 10px;">
                      <strong>${item.target}</strong><br/>
                      DA: ${item.da}<br/>
                      Domain: ${item.domain}%
                    </div>
                  `;
                    },
                  },
                }}
              />
            </Box>
          </Grid>

        </Grid>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp className="datagrid_custom_scroll"
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0]}
                  tableLoading={tableLoading}
                  handleModelPopUp={handleModelPopUp}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  DownloadShowFile={true}
                  customFilter={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Dialog
        open={OpenModalJob}
        onClose={CloseModalJobTrigger}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter"
      >
        <DialogTitle className="keyword-dialog-header">
          {"Filter By"}
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap">
              <div>
                <div className="">
                  <div>
                    <span className="select_filter_text">Completed Date</span>
                    <Select
                      value={dEngineoption}
                      options={completedate}
                      placeholder="Select..."
                      labelField="completed_at"
                      valueField="id"
                      onChange={(values) => {
                        setSelectval(values);
                        SetdEngineoption(values);
                      }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                    />
                  </div>
                </div>

                <div className="col">
                  <span className="text-error">{validationFiter}</span>
                </div>
              </div>

              <div style={{ marginTop: "12px" }}>
                <div>
                  <label>Follow Type:</label>
                </div>

                <div>
                  <Select
                    value={FollowType}
                    options={[
                      { value: "all", label: "All" },
                      { value: "follow", label: "Follow" },
                      { value: "nofollow", label: "No Follow" },
                    ]}
                    placeholder="Select..."
                    defaultValue={{ value: "all", label: "All" }}
                    onChange={(e) => {
                      SetFollowType(e);
                      SetFollowTypeErr("");
                    }}
                    styles={customDropdownStyles()}
                    menuPortalTarget={document.body}
                  />
                </div>

                <div className="col">
                  <span className="text-error">{followTypeErr}</span>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>

        <DialogActions className="dialog-action-button">
          <button
            className="keyword-submit"
            onClick={TriggerFilter}
          >
            Submit
          </button>

          <button className="keyword-cancel" onClick={CloseModalJobTrigger}>
            Close
          </button>

          <button className="keyword-cancel" onClick={handleFilterReset}>
            Reset
          </button>
        </DialogActions>
      </Dialog>
      {/* <div >
        <DatagridComp
          columns={columns}
          rows={rows}
          autoheightval={autoheightval}
          datagridval={2}
          columnFreezeWidth={[0]}
          tableLoading={tableLoading}
        />

      </div> */}
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }
      <UserActivityTracker pagename="Backlinks - New/Lost Links - New Link" />
    </div>
  );
}
